import { Expose } from 'class-transformer';
import { IsArray, IsString } from 'class-validator';

export class CustomersExportReportDto {
  @IsArray()
  @IsString({ each: true })
  @Expose()
  include: string[];
}
